import { create } from 'zustand';

import { createPanelSlice, type PanelSlice } from '~/components/v2/store/shared/createPanelSlice';

export type WorkspaceActivityState = PanelSlice;

export const useWorkspaceActivityStore = create<WorkspaceActivityState>()((...args) => ({
  ...createPanelSlice({ open: false })(...args),
}));
